import { useEffect, useRef } from 'react';
import { useSidebar } from '@/components/ui/sidebar';

export default function DocumentationLayout({ active }) {
  const { open, setOpen, setOpenMobile } = useSidebar();
  const entered = useRef(false);
  const previous = useRef(open);
  useEffect(() => {
    if (active && !entered.current) {
      previous.current = open;
      entered.current = true;
      setOpen(false);
      setOpenMobile(false);
    } else if (!active && entered.current) {
      entered.current = false;
      setOpen(previous.current);
    }
  }, [active, open, setOpen, setOpenMobile]);
  return null;
}
